// extracted by mini-css-extract-plugin
module.exports = {"holder":"SimpleDateInput--holder","day":"SimpleDateInput--day","month":"SimpleDateInput--month","year":"SimpleDateInput--year"};